import { render, staticRenderFns } from "./leecheroIndex.vue?vue&type=template&id=66c8f520&"
import script from "./leecheroIndex.vue?vue&type=script&lang=js&"
export * from "./leecheroIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports